// src/Components/CreditCardCheckout.jsx
import React, { useState } from 'react';
import PaymentService from '../services/PaymentService';

const CreditCardCheckout = ({ product, onSuccess, onCancel }) => {
  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: '',
    cardholderName: '',
    expiryDate: '',
    cvv: '',
    billingAddress: '',
    zipCode: ''
  });
  
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentDetails({
      ...paymentDetails,
      [name]: value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    setError(null);
    
    try {
      // In a real implementation, you would use a secure payment form
      // like Stripe Elements rather than handling card details directly
      const result = await PaymentService.processCardPayment(paymentDetails, product);
      
      setIsProcessing(false);
      if (result.success) {
        onSuccess(result.transactionId);
      } else {
        setError(result.message || 'Payment failed');
      }
    } catch (err) {
      setIsProcessing(false);
      setError(err.message || 'An error occurred during payment processing');
    }
  };
  
  return (
    <div className="credit-card-checkout">
      <h2>Purchase NFT with Credit Card</h2>
      <p className="checkout-info">
        Your NFT will be stored in your account's secure wallet. No crypto wallet needed!
      </p>
      
      {error && <div className="checkout-error">{error}</div>}
      
      <form onSubmit={handleSubmit} className="credit-card-form">
        <div className="form-group">
          <label htmlFor="cardholderName">Cardholder Name</label>
          <input
            type="text"
            id="cardholderName"
            name="cardholderName"
            value={paymentDetails.cardholderName}
            onChange={handleInputChange}
            required
            placeholder="Name on card"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="cardNumber">Card Number</label>
          <input
            type="text"
            id="cardNumber"
            name="cardNumber"
            value={paymentDetails.cardNumber}
            onChange={handleInputChange}
            required
            placeholder="XXXX XXXX XXXX XXXX"
            maxLength="19"
          />
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="expiryDate">Expiry Date</label>
            <input
              type="text"
              id="expiryDate"
              name="expiryDate"
              value={paymentDetails.expiryDate}
              onChange={handleInputChange}
              required
              placeholder="MM/YY"
              maxLength="5"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="cvv">CVV</label>
            <input
              type="text"
              id="cvv"
              name="cvv"
              value={paymentDetails.cvv}
              onChange={handleInputChange}
              required
              placeholder="123"
              maxLength="4"
            />
          </div>
        </div>
        
        <div className="form-group">
          <label htmlFor="billingAddress">Billing Address</label>
          <input
            type="text"
            id="billingAddress"
            name="billingAddress"
            value={paymentDetails.billingAddress}
            onChange={handleInputChange}
            required
            placeholder="Enter your billing address"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="zipCode">Zip Code</label>
          <input
            type="text"
            id="zipCode"
            name="zipCode"
            value={paymentDetails.zipCode}
            onChange={handleInputChange}
            required
            placeholder="Zip/Postal Code"
          />
        </div>
        
        <div className="price-summary">
          <div className="price-row">
            <span>Price:</span>
            <span>{product.price} ETH (${(product.price * 3500).toFixed(2)} USD)</span>
          </div>
          <div className="price-row">
            <span>Processing Fee:</span>
            <span>$2.99</span>
          </div>
          <div className="price-row total">
            <span>Total:</span>
            <span>${((product.price * 3500) + 2.99).toFixed(2)}</span>
          </div>
        </div>
        
        <div className="checkout-actions">
          <button 
            type="button" 
            className="cancel-button"
            onClick={onCancel}
            disabled={isProcessing}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="purchase-button"
            disabled={isProcessing}
          >
            {isProcessing ? 'Processing...' : 'Complete Purchase'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreditCardCheckout;